import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToFirstPage() {
      if (!this.disabled && this.currentPage !== 1) {
        this.$emit('change', 1);
      }
    },
    goToPrevPage() {
      if (!this.disabled && this.currentPage > 1) {
        this.$emit('change', Math.max(1, this.currentPage - 1));
      }
    },
    goToNextPage() {
      if (!this.disabled && this.currentPage < this.totalPages) {
        this.$emit('change', Math.min(this.totalPages, this.currentPage + 1));
      }
    },
    goToLastPage() {
      if (!this.disabled && this.currentPage !== this.totalPages) {
        this.$emit('change', this.totalPages);
      }
    }
  }
});
